import BaseService from "../BaseService";
import _ from "lodash";

class ImageService extends BaseService {
    upload = async (formdata) => {
        var image = this._api.post("image/upload", formdata)
        return image;
    };
    uploadLogo = async (formdata) => {
        var image = this._api.post("logo/upload", formdata)
        return image;
    };

    delete = async (id) => {
        var image = this._api.post("image/delete", { id: id })
        return image;
    };
    deleteList = async (ids) => {
        var image = this._api.post("image/delete_list", { ids })
        return image;
    };

    moveList = async (ids, folder_id) => {
        var image = this._api.post("image/move_list", { ids, folder_id })
        return image;
    };


    list = async (folder) => {
        var image = this._api.post("image/list", { folder })
        return image;
    };

    createFileSize = async () => {
        var image = this._api.post("image/create_filesize")
        return image;
    }





}
export default ImageService;
